import { Injectable, Param, Query } from "@nestjs/common";
import { Repository, Raw, getConnection, getManager } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { DownTimeTrackingStatusEnum, ErrorResponse, GlobalVariableValues, MessageParameters, MessageRequest } from '@gtpl/shared-models/common-models';
import { DownTimeTracking } from "./dto/downtime-tracking.entity";
import { DowntimeTrackingDto } from "./dto/downtime-tracking.dto";
import { DownTimeDashboardDateRequest, DownTimePieChartDto, DowntimePiechartResonseModel, DownTimeTrackingResponsemodel,DowntimeTrackingMachineNameResponseModell,DowntimeTrackingMacineNameResponse} from "@gtpl/shared-models/masters";
import { AllDownTimeTrackingResponseModel } from "@gtpl/shared-models/masters";
import { DownTimeTrackingAdapter } from "./dto/downtime-tracking.adapter";
import { DowntimeMachineNameRequest, DownTimeTrackingPiechartRequest, DownTimeTrackingRequest } from "./dto/downtime-tracking.request";
import appSettings from "apps/services/config";
import { CommonResponse } from "@gtpl/shared-models/production-management";
// import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import moment = require("moment");
import { ForkLiftJobService } from "@gtpl/shared-services/warehouse-management";
import { DeviceRequest } from "@gtpl/shared-models/warehouse-management";
import { EmployeeByUnitRequest } from "../employee-details/dto/employee-by-unit-request";
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { Cron } from "@nestjs/schedule";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import whatsApp from "apps/services/whatsapp";


@Injectable()

export class DownTimeTrackingService {
  manager: any;
  constructor(
    private logService:LogsService,

    @InjectRepository(DownTimeTracking)
    private downtimetrackingRepository: Repository<DownTimeTracking>,
    private downtimeTrackingAdapter: DownTimeTrackingAdapter,
    // private wpService: WhatsAppNotificationService,
    private ForkLiftJobsService:ForkLiftJobService,
    private wtsAppBroadCatService : WhatsappBroadCastService,

  ) { }

  async createDownTimeTracking(downtimeTrackingDto: DowntimeTrackingDto, isUpdate: boolean): Promise<DownTimeTrackingResponsemodel> {
    const time = moment().format("DD-MM-YYYY HH:mm")

    const convertedDownTimeTrackingEntity: DownTimeTracking = this.downtimeTrackingAdapter.convertDtoToEntity(downtimeTrackingDto, isUpdate);
    convertedDownTimeTrackingEntity.employeeId = downtimeTrackingDto.employeeId
    const savedDowntimeEntity: DownTimeTracking = await this.downtimetrackingRepository.save(
      convertedDownTimeTrackingEntity
    );
    console.log(savedDowntimeEntity,'savedDowntimeEntity')
    const savedDownTimeTrackingDto: DowntimeTrackingDto = this.downtimeTrackingAdapter.convertEntityToDto(convertedDownTimeTrackingEntity);
    if (savedDownTimeTrackingDto) {
      const response = new DownTimeTrackingResponsemodel(true, 1, isUpdate ? 'DowntimeTracking Updated Successfully' : 'DownTimeTracking Created Successfully')
      const manager = getManager();
      let query=' SELECT i.item_name as assetName,a.assets_name AS assetId,i.asset_priority AS assetPriority,i.asset_sla AS assetSla,dr.downtime_reason AS reason,dt.status AS status,dt.downtime_type AS downtimetype,dt.category AS category,dt.resolution AS resolution,dt.no_of_resources AS resources,dt.impact AS impact,dt.startTime AS startTime,dt.endtime AS endTime,TIMESTAMPDIFF(HOUR,dt.startTime,dt.endtime) AS duration,TIMESTAMPDIFF(MINUTE,dt.startTime,NOW()) AS timelag FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.downtime_reason dr ON dr.downtimereason_id=dt.reason_Id LEFT JOIN '+appSettings.assets_db+'.assets a ON a.asset_id=dt.asset_id LEFT JOIN '+appSettings.masters_db+'.items i ON a.assets_name=i.item_id  where downtimeTreacking_id='+savedDownTimeTrackingDto.downtimeTrackingId+' limit 1';
      const result = await manager.query(query)
      console.log(result,'Result')
      let mobileNumber ;
      if(downtimeTrackingDto.assetId){
        const mobileQuery='SELECT a.owner_of_asset as employeeId,ed.employee_name employeeName,mobile_no AS mblno FROM '+appSettings.assets_db+'.assets a left join '+appSettings.masters_db+'.employee_details ed on ed.employee_id=a.owner_of_asset WHERE assets_name='+savedDownTimeTrackingDto.assetId+' '

        const mobileNoData = await manager.query(mobileQuery)
      //  if(mobileNoData[0].mblno){
      //     if( mobileNoData[0].mblno.length == 12){
      //       mobileNumber = mobileNoData[0].mblno
      //     }else{
      //       mobileNumber = '91' + mobileNoData[0].mblno
      //       console.log(mobileNumber)
      //     }
      //  }
      //  else{
      //   const response = new DownTimeTrackingResponsemodel(false, 1, 'No mobile Number exist to sent whatsapp message')
      //   return response;
      //  }
        
      }
      let message;
      let deviceRequest
      
      if(savedDownTimeTrackingDto.status=='OPEN'){
        //  deviceRequest = new DeviceRequest(true,169,'192.168.0.166','FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS','lights',2,2,'state');
           const parameters =[
            { "type": "text", "text": time },
            { "type": "text", "text": result[0].downtimetype  ? "*" + result[0].downtimetype + "*" : "No Data" },
            { "type": "text", "text": result[0].assetName ? "*" + result[0].assetName + "*" : "No Data" },
            { "type": "text", "text": result[0].assetPriority ? "*" + result[0].assetPriority + "*" : "No Data" },
            { "type": "text", "text": result[0].assetSla ? "*" + result[0].assetSla + "*" : "No Data" },
            { "type": "text", "text": result[0].status ? "*" + result[0].status + "*" : "No Data" }
            
           ]
          //  const contacts = mobileNumber;
           const contacts = whatsApp.contacts;
           let statusFlag
          for (const contact of contacts) {    
           const req = await new MessageParameters(contact, 'downtime_status_for_open', parameters, 'en_us')
          //  const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
          //  console.log(messageStatus, 'messageStatus')
          //  if (!messageStatus.status) {
          //    statusFlag = false
          //    break
          //  } else {
          //    statusFlag = true
          //    const whatsapplogDto = new WhatsAppLogDto(contact,'downtime_status_for_open','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.downtimeModuleId)
          //    console.log(whatsapplogDto,'whatsapplogDto')
          //    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
          //  }
         }
         if (statusFlag) {
           return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
         }  

      } 
        else if(savedDownTimeTrackingDto.status=='WIP' || savedDownTimeTrackingDto.status=='PENDING'){
          const parameters =[
            { "type": "text", "text": time },
            { "type": "text", "text": result[0].downtimetype ? "*" + result[0].downtimetype + "*" : "No Data" },
            { "type": "text", "text": result[0].status  ? "*" + result[0].status + "*" : "No Data" },
            { "type": "text", "text": result[0].assetName ? "*" + result[0].assetName + "*" : "No Data" },
            { "type": "text", "text": result[0].assetSla ? "*" + result[0].assetSla + "*" : "No Data" },
            { "type": "text", "text": result[0].timelag ? "*" + result[0].timelag + "*" : "No Data" },
            { "type": "text", "text": result[0].reason ? "*" + result[0].reason + "*" : "No Data" },
            { "type": "text", "text": result[0].impact ? "*" + result[0].impact + "*" : "No Data" },
           ]
           const contacts = whatsApp.contacts;
           let statusFlag
           for (const contact of contacts) {    
            const req = await new MessageParameters(contact, 'downtime_for_inprogress', parameters, 'en_us')
            // const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
          //   console.log(messageStatus, 'messageStatus')
          //   if (!messageStatus.status) {
          //     statusFlag = false
          //     break
          //   } else {
          //     statusFlag = true
          //     const whatsapplogDto = new WhatsAppLogDto(contact,'downtime_for_inprogress','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.downtimeModuleId)
          //     console.log(whatsapplogDto,'whatsapplogDto')
          //     await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
          //   }
          }
          if (statusFlag) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
          }  
      }
      else if(savedDownTimeTrackingDto.status=='CLOSE'){
        // deviceRequest = new DeviceRequest(false,22500,'192.168.0.166','FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS','lights',2,2,'state');
          const parameters =[
            { "type": "text", "text": time },
            { "type": "text", "text": result[0].downtimetype ? "*" + result[0].downtimetype + "*" : "No Data" },
            { "type": "text", "text": result[0].assetName ? "*" + result[0].assetName + "*" : "No Data" },
            { "type": "text", "text": result[0].reason ? "*" + result[0].reason + "*" : "No Data" },
            { "type": "text", "text": result[0].duration ? "*" + result[0].duration + " hrs"+"*" : "No Data" },
            { "type": "text", "text": result[0].impact ? "*" + result[0].impact + "*" : "No Data" },
            { "type": "text", "text": result[0].resolution ? "*" + result[0].resolution +"*" : "No Data" },
            { "type": "text", "text": result[0].status  ? "*" + result[0].status + "*" : "No Data" },
           ]
           console.log(parameters, 'parameters')
           const contacts = whatsApp.contacts;
           let statusFlag
           for(const contact of contacts){
            const req = await new MessageParameters(contact, 'downtime_for_closing_status', parameters, 'en_us')
            // const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            // if (!messageStatus.status) {
            //   statusFlag = false
            // } else {
            //   statusFlag = true
            //   const whatsapplogDto = new WhatsAppLogDto(contact,'downtime_for_closing_status','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.downtimeModuleId)
            //   await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
            // }
           }
           
          if (statusFlag) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
          } 
      }   
      var lightreq = await  this.ForkLiftJobsService.getOperateDevice(deviceRequest);
      return response
    } else {
      throw new DownTimeTrackingResponsemodel(false, 11106, 'DowntimeTracking saved but issue while transforming into DTO');
    }


  }


  async getAllDownTimeTrackings(req:EmployeeByUnitRequest): Promise<AllDownTimeTrackingResponseModel> {

    try {
      const manager = getManager();
      let query = 'SELECT l.location_name as assetLocation,dt.unit_id,dt.machine_code as assetCode,uc.unit_name as plant,dt.asset_category_id as assetCategoryId,isc.item_sub_category as assetCategory,i.asset_sla AS assetSla,i.asset_priority AS assetPriority,a.assets_code AS machineCode,a.assets_name AS assetId,i.item_name as assetName,dt.downtimeTreacking_id AS downtimeTrackingId,dt.asset_id AS assetId,dt.department_Id AS departmentId,dt.category AS category,dt.startTime AS startTime,dt.reason_Id AS reasonId,dt.status AS status,dt.no_of_resources AS resources,dt.endtime AS endtime,dt.impact AS impact,dt.remarks AS remarks,dt.saleorder_Id AS saleorderId,dt.machine_name AS machineName,dt.created_at AS createdAt,dt.is_active AS isActive,dt.version_flag AS versionFlag,dr.sla AS sla,TIMESTAMPDIFF(MINUTE,dt.startTime,NOW()) AS duration,TIMEDIFF(NOW(),dt.startTime) AS diffhours,dr.downtime_reason AS reason,dt.downtime_type AS downtimeType FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.downtime_reason dr ON dr.downtimereason_id = dt.reason_id LEFT JOIN '+appSettings.assets_db+'.assets a ON a.assets_name=dt.asset_id LEFT JOIN '+appSettings.masters_db+'.items i on i.item_id=a.assets_name left join '+appSettings.masters_db+'.item_sub_categories isc ON isc.item_sub_category_id=dt.asset_category_id left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=dt.unit_id left join '+appSettings.assets_db+'.asset_location_mapping alm on alm.asset_id=dt.asset_id left join '+appSettings.assets_db+'.location l on alm.location_id=l.location_id  WHERE dt.status NOT IN ("CLOSE","CANCEL") ';
     if(req.unitId >0 && req.unitId !=5){
      query = query+' and dt.unit_id='+req.unitId+' GROUP BY downtimeTreacking_id ORDER BY duration DESC'
     }else{
      query = query+' GROUP BY downtimeTreacking_id ORDER BY duration DESC'
     }
      const result: DowntimeTrackingDto[] = await manager.query(query)
      if (result) {
        const res1 = new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
        const newLogDto = new LogsDto(1,'view', 'DownTimeTracking', 0, true, '','')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        return res1;
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }

    } catch (err) {
      return err;
    }
  }



  async gettrackingGroupbyReason(req: DownTimeTrackingPiechartRequest): Promise<DowntimePiechartResonseModel> {
    try {
      const manager = getManager();
      let query = 'SELECT COUNT(dt.reason_Id) * 100 / (SELECT COUNT(*) FROM '+appSettings.masters_db+'.downtime_tracking) AS percent , dr.downtime_reason AS reason FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.downtime_reason dr ON dr.downtimereason_id = dt.reason_Id where Date(dt.created_at) between  "' + req.fromDate + '" and "' + req.toDate + '"  GROUP BY dt.reason_Id';

      // if (req.fromDate != undefined) {
      //   query = query + ' where date(dt.created_at) between  "' + req.fromDate + '" and "' + req.toDate + '"';
      // }
      // query = query + ' GROUP BY dt.reason_Id'
      const result: DownTimePieChartDto[] = await manager.query(query)
      if (result.length) {
        return new DowntimePiechartResonseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new DowntimePiechartResonseModel(false, 1111, "Error occured")

      }
    }
    catch (err) {
      return err;
    }

  }


  async getAllActiveDownTimeTracking(): Promise<AllDownTimeTrackingResponseModel> {
    // const page: number = 1;
    try {
      const DowntimeTrackingDto: DownTimeTracking[] = [];
      //retrieves all companies
      const DowntimeTrackingEntities: DownTimeTracking[] = await this.downtimetrackingRepository.find({
        order: { 'category': 'ASC' }, where: { isActive: true },
      });
      if (DowntimeTrackingEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        DowntimeTrackingEntities.forEach(downtimetrackingnEntity => {
          const converteddowntimetrackingDto: DowntimeTrackingDto = this.downtimeTrackingAdapter.convertEntityToDto(
            downtimetrackingnEntity

          );
          DowntimeTrackingDto.push(converteddowntimetrackingDto);
        });
        const response = new AllDownTimeTrackingResponseModel(true, 11108, "Downtimetracking retrieved successfully", DowntimeTrackingDto);
        return response;
      } else {
        throw new DownTimeTrackingResponsemodel(false, 99998, 'Data not found'); DowntimeTrackingDto
      }
    } catch (err) {
      return err;
    }
  }


  async activateOrDeactivateDownTimeTracking(downtimetrackingReq: DownTimeTrackingRequest): Promise<DownTimeTrackingResponsemodel> {
    try {
      const DownTimeTrackingExists = await this.getDowTimeTrackingById(downtimetrackingReq.downtimeTrackingId);
      if (DownTimeTrackingExists) {
        if (downtimetrackingReq.versionFlag !== DownTimeTrackingExists.versionFlag) {
          throw new DownTimeTrackingResponsemodel(false, 10113, 'Someone updated the current DownTimetracking information.Refresh and try again');
        } else {

          const downtimeTrackingStatus = await this.downtimetrackingRepository.update(
            { downtimeTrackingId: downtimetrackingReq.downtimeTrackingId },
            { isActive: downtimetrackingReq.isActive, updatedUser: downtimetrackingReq.updatedUser });

          if (DownTimeTrackingExists.isActive) {
            if (downtimeTrackingStatus.affected) {
              const downtimetrackingResponse: DownTimeTrackingResponsemodel = new DownTimeTrackingResponsemodel(true, 10115, 'Downtimetracking is de-activated successfully');
              return downtimetrackingResponse;
            } else {
              throw new DownTimeTrackingResponsemodel(false, 10111, 'DownTime is already deactivated');
            }
          } else {
            if (downtimeTrackingStatus.affected) {
              const DownTimeTrackingResponse: DownTimeTrackingResponsemodel = new DownTimeTrackingResponsemodel(true, 10114, 'DowntimeTracking is activated successfully');
              return DownTimeTrackingResponse;
            } else {
              throw new DownTimeTrackingResponsemodel(false, 10112, 'DownTimetracking is already  activated');
            }
          }
          // }
        }
      } else {
        throw new DownTimeTrackingResponsemodel(false, 99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }


  async getActiveDownTimeTrackingById(downtimeTrackingReq: DownTimeTrackingRequest): Promise<DownTimeTrackingResponsemodel> {
    try {
      //retrieves all companies
      const DowntimeTrackingEntities: DownTimeTracking = await this.downtimetrackingRepository.findOne({
        where: { downtimeTrackingId: downtimeTrackingReq.downtimeTrackingId }
      });

      const downtimeTrackingsData: DowntimeTrackingDto = this.downtimeTrackingAdapter.convertEntityToDto(DowntimeTrackingEntities);
      if (downtimeTrackingsData) {
        const response = new DownTimeTrackingResponsemodel(true, 11101, 'Downtimetracking retrived Successfully', downtimeTrackingsData);
        return response;
      }
      else {
        throw new DownTimeTrackingResponsemodel(false, 11106, 'Something went wrong');
      }
      // generating resposnse
    } catch (err) {
      return err;
    }
  }


  async getDowTimeTrackingById(downtimeTrackingId: number): Promise<DownTimeTracking> {
    const Response = await this.downtimetrackingRepository.findOne({
      where: { downtimeTrackingId: downtimeTrackingId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }


  async gettrackingDepartmentData(): Promise<AllDownTimeTrackingResponseModel> {
    try {
      const manager = getManager();
      const query = 'SELECT dr.dept_name AS departmentname,dt.downtime_type,dt.startTime,dt.endtime,TIMESTAMPDIFF(HOUR,startTime,now()) AS hours FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.departments dr ON dt.department_id = dr.dept_id WHERE dt.status NOT IN("CLOSE","CANCEL") ORDER BY hours DESC';
      const result: DowntimeTrackingDto[] = await manager.query(query)
      if (result) {
        return new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }
    }
    catch (err) {
      return err;
    }

  }
  async getTotalDowntimeDepartmentWise(): Promise<AllDownTimeTrackingResponseModel> {
    try {
      const manager = getManager();
      // const totalCountQuery = 'select COUNT(*) FROM  `erpx_dev_masters`.downtime_tracking'
      // const totalCount = await manager.query(totalCountQuery)
      const query = 'SELECT dr.dept_name AS departmentname,SUM(dt.no_of_resources) AS resources ,SUM(TIMESTAMPDIFF(HOUR,dt.startTime,dt.endtime)) AS hours,100-((no_of_resources*SUM(TIMESTAMPDIFF(HOUR,dt.startTime,dt.endtime)))/(no_of_resources*10)) AS utilization FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.departments dr ON dt.department_id = dr.dept_id WHERE dt.status="CLOSE" GROUP BY dt.department_id';
      const result: DowntimeTrackingDto[] = await manager.query(query)
      if (result) {
        return new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }
    }
    catch (err) {
      return err;
    }

  }

  async getTotalDownTimeType(): Promise<AllDownTimeTrackingResponseModel> {
    try {
      const manager = getManager();
    
      const query = ' SELECT Status,COUNT(IF(DOWNTIME_TYPE = "UN PLANNED",1,NULL))AS unplannedCount,COUNT(IF(downtime_type="PLANNED",1,NULL)) AS plannedCount,COUNT(downtime_type) AS statuscount FROM '+appSettings.masters_db+'.downtime_tracking WHERE STATUS NOT IN ("CLOSE","CANCEL") GROUP BY STATUS';
      const result: DowntimeTrackingDto[] = await manager.query(query)
      if (result) {
        return new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }
    }
    catch (err) {
      return err;
    }

  }
  async getTotalSkippedSlaAndUndeSla(): Promise<AllDownTimeTrackingResponseModel> {
    try {
      const manager = getManager();
    
      const query = ' SELECT status,i.asset_sla AS assetSla,COUNT(IF(TIMESTAMPDIFF(MINUTE,dt.startTime,NOW()) > i.`asset_sla`,1,NULL)) AS skippedsla,COUNT(IF(TIMESTAMPDIFF(MINUTE,dt.startTime,NOW()) < i.`asset_sla`,1,NULL)) AS undersla FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.items i ON i.item_id=dt.asset_id WHERE  dt.status NOT IN("CLOSE","CANCEL")  GROUP BY STATUS';
      const result: DowntimeTrackingDto[] = await manager.query(query)
      if (result) {
        return new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }
    }
    catch (err) {
      return err;
    }

  }

  async getMachineName(req:DowntimeMachineNameRequest): Promise <CommonResponse> {
    try{
  const manager = getManager();
  const query ='SELECT a.asset_category as assetCategoryId,i.asset_sla AS assetSla,a.assets_name AS assetId,i.item_name AS assetName,assets_code AS assetCode FROM '+appSettings.assets_db+'.assets a LEFT JOIN '+appSettings.masters_db+'.items i ON a.assets_name=i.item_id where asset_category='+req.assetCategoryId+''

  const result= await manager.query(query)
  if(result.length >0){
    return new CommonResponse(true, 1111, "Data retreived sucessfully",result)

  }else{
    return new CommonResponse(false, 1111, "Error occured. ")

  }
    }
    catch(err){
    return err;
    }


  }


  async getDownTimeTrackingReport(): Promise<AllDownTimeTrackingResponseModel> {
    // const page: number = 1;

    try {
      // const downtimeTrackingDto: DownTimeTrackingDto[] = [];
      const manager = getManager();
      let query = 'select dt.downtimeTreacking_id as downtimeTrackingId,dt.department_Id as departmentId,dt.category as category,dt.startTime as startTime,dt.reason_Id as reasonId,dt.status as status,dt.no_of_resources as resources,dt.endtime as endtime,dt.impact as impact,dt.remarks as remarks,dt.saleorder_Id as saleorderId,dt.machine_name as machineName,dt.created_at as createdAt,dt.is_active as isActive,dt.version_flag as versionFlag,dr.sla as sla,TIMESTAMPDIFF(MINUTE,dt.startTime,NOW()) as duration,TIMEDIFF(NOW(),dt.startTime) AS diffhours,dr.downtime_reason as reason from '+appSettings.masters_db +'.downtime_tracking dt left join ' + appSettings.masters_db + '.downtime_reason dr on dr.downtimereason_id = dt.reason_id  ORDER BY duration DESC';
      // query = query + " order by createdAt DESC"
      const result: DowntimeTrackingDto[] = await manager.query(query)
      //console.log('hhhh')
      if (result) {
        return new AllDownTimeTrackingResponseModel(true, 1111, "Data retreived sucesssfuly", result)
      } else {
        return new AllDownTimeTrackingResponseModel(false, 1111, "Error occure")

      }

    } catch (err) {
      return err;
    }
  }

  @Cron('0 0 20 * *')
  async alertMessageforSkipedSlaMachine(){
  try{
    let summarydata: string[]=[]
    const time = moment().format('MMMM Do, YYYY');
      const manager=getManager();
      let query=' SELECT i.item_name AS assetName,a.assets_name AS assetId,dt.status AS status,dt.downtime_type AS downtimetype,dt.impact AS impact,dt.startTime AS startTime,TIMESTAMPDIFF(HOUR,dt.startTime,NOW()) AS duration FROM '+appSettings.masters_db+'.downtime_tracking dt LEFT JOIN '+appSettings.masters_db+'.downtime_reason dr ON dr.downtimereason_id=dt.reason_Id LEFT JOIN '+appSettings.assets_db+'.assets a ON a.assets_name=dt.asset_id left join '+appSettings.masters_db+'.items i ON i.item_id = dt.asset_id WHERE DATE(dt.created_at)=CURDATE()';
      const result =await manager.query(query)
      let msg
      if(result.length>0){   
        for(const res of result){     
          msg += "\nType : *" + res.downtimetype+'*\n'+ 
          "\nAssetName : *" + res.assetName+'*\n'+ 
            "\nStatus : *" + res.status+'*\n'+
            "\nDuration : *" + res.duration+''+'hrs'+'*\n';
        }    
        summarydata.push(msg);

      }
      else {
        summarydata.push("No Downtime occured As perToday \n")
    }
        const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(24,time+'\n'+summarydata,['919502201959']));
        if (messageStatus.status) {
          return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            }


      }catch(error) {
        console.log(error,'error')
        return new CommonResponse(false, 11508, "Error while sending message")

      }
  }

  async downtimeventcalnder(): Promise<CommonResponse>{
    try{
      const manager= getManager();
      const query = 'SELECT  downtimeTreacking_id as id,i.item_name as title,startTime AS start,TIMESTAMPADD(MINUTE,i.asset_sla,startTime) AS end  FROM '+appSettings.masters_db+'.downtime_tracking d LEFT JOIN '+appSettings.assets_db+'.assets a ON a.assets_name=d.asset_id left join '+appSettings.masters_db+'.items i on i.item_id=d.asset_id';
      const result =await manager.query(query)
      if (result) {
        const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        const newLogDto = new LogsDto(1,'calender view', 'DownTimeTracking', 0, true, res.internalMessage,'')
              let res1 = await this.logService.createLog(newLogDto);
              console.log(res);
        return res;
      } else {
        return new CommonResponse(false, 1111, "Error occure")

      }

    }catch(err){
      return err;
    }

  }
   
  async assetCategoryDropDown(): Promise<CommonResponse>{
    const manager = getManager();
    const query = 'SELECT item_sub_category_id AS itemSubCategoryId,item_sub_category AS itemCategory FROM '+appSettings.masters_db+'.item_sub_categories'
    const result = await manager.query(query)
    if(result.length>0){
      return new CommonResponse(true,1000,'Data Retrived Sucessfullyy..',result)
    }else{
      return new CommonResponse(false,1000,'no data Found')
    }
  }

}
 


